import { useTranslation } from 'react-i18next';
import { ApiError } from '@/lib/api';
import { useErrorMessage } from '@/lib/query';

/** Password-flow error codes live in the `auth` namespace; anything else falls back to common errors. */
export function usePasswordErrorMessage() {
  const { t, i18n } = useTranslation('auth');
  const generic = useErrorMessage();
  return (err: unknown) => {
    if (err instanceof ApiError && err.status === 429) return t('errors.RATE_LIMITED');
    if (err instanceof ApiError && i18n.exists(`auth:errors.${err.code}`)) return t(`errors.${err.code}`);
    return generic(err);
  };
}
